export class ImageannotationModel {
  base64Image: string = "";
  annotedbase64Image: string = "";
  imageName: string = "";
  imageType: string = "";
}
